<template>
  <div class="featured-products-component">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="product-text text-center">
            <h2>Dutché More Like It!</h2>
            <p>
              Your favorite Dutché chocolate delivered at your doorstep!
              <br />Now you can order online from our authorized Shopee and Lazada sellers. Shop now!
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-5">
      <div class="row featured-products">
        <div class="col-12 col-md-6">
          <div class="product-container" v-if="mainProduct">
            <div class="product-image box" :style="background(mainProduct.image)">
              <div class="product-details">
                <h2 class="">{{ mainProduct.name }}</h2>
                <p class="d-none d-md-block">{{ trimDescription(mainProduct.description) }}</p>
              </div>
              <div class="product-overlay">
                <div class="product-hover-details">
                  <h2>{{ mainProduct.name }}</h2>
                  <p>{{ trimDescription(mainProduct.description) }}</p>
                  <div class="buy-now">
                    <button class="btn btn-dutche-brown d-none d-lg-inline" v-b-modal.featured-product-preview @click="getFeaturedProductSlug(mainProduct.slug)">Buy Now</button>
                    <a class="btn btn-dutche-brown d-inline d-lg-none" :href="`/product/${mainProduct.slug}`">Buy Now</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6" v-if="products">
          <div class="row">
            <div class="col-6" v-for="(product, index) in products" :key="index" :class="[2,3].includes(index) ? 'bottom-product' : ''">
              <div class="product-container">
                <div class="product-image box top-product" :style="background(product.image)">
                  <div class="product-details">
                    <p class="font-weight-bold text-shadow">{{ trimName(product.name) }}</p>
                    <p class="d-none d-md-block">Php {{ product.price }}</p>
                    <p class="d-md-none d-block price">Php {{ product.price }}</p>
                  </div>
                  <div class="product-overlay">
                    <div class="product-hover-details">
                      <strong>{{ trimName(product.name) }}</strong>
                      <p class="d-none d-lg-block">Php {{ product.price }}</p>
                      <div class="buy-now">
                        <button class="btn btn-dutche-brown d-none d-lg-inline" v-b-modal.featured-product-preview @click="getFeaturedProductSlug(product.slug)">Buy Now</button>
                        <a class="btn btn-dutche-brown d-inline d-lg-none" :href="`/product/${product.slug}`">Buy Now</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FeaturedProductModal :productSlug="productSlug"></FeaturedProductModal>
  </div>
</template>

<script>
import FeaturedProductModal from "@/components/FeaturedProductModal";

export default {
  name: "FeaturedProducts",
  props: {
    mainProduct: Object,
    products: Array
  },
  data() {
    return {
      productSlug: undefined
    }
  },
  components: {
    FeaturedProductModal
  },
  methods: {
    background(imageUrl) {
      return { background: `url(${imageUrl}), linear-gradient(to bottom, white, #f5f5f5)` };
    },
    trimDescription(description) {
      return description.substr(0, 50) + "...";
    },
    trimName(name) {
      return name.substr(0, 12);
    },
    getFeaturedProductSlug(slug) {
      return this.productSlug = slug;
    }
  }
};
</script>

<style lang="sass" scoped>
.featured-products-component
  font-size: 16px
  
h2
  font-family: "Might Could"

.product-text
  margin-top: 8rem
  & h2
    font-size: 2em
  
.box
  padding-bottom: 100%
  background-size: contain !important
  background-repeat: no-repeat !important
  background-position: center center !important
  background-blend-mode: multiply

.product-image
  background-position: center
  background-size: cover

.product-container
  position: relative

  .product-overlay
    position: absolute
    top: 0
    bottom: 0
    left: 0
    right: 0
    height: 100%
    width: 100%
    opacity: 0
    transition: 0s ease
    background-color: $dutche-primary-yellow
    color: $dutche-primary-brown

  .product-details
    position: absolute
    bottom: 20%
    padding-left: 5%
    padding-right: 5%
    color: $dutche-primary-violet
    bottom: 0
    width: 100%
    padding: 15px 20px

    .price
      font-size: 0.8em

.product-container:hover
  .product-overlay
    opacity: 1
    .buy-now
      display: block
    .product-hover-details 
        left: 0
        right: 0
        margin-top: 30%
        text-align: center

.btn-dutche-brown
  text-transform: uppercase
  border-radius: 0.5rem
  background-color: $dutche-primary-brown
  color: $white

.bottom-product
  margin-top: 30px

.text-shadow
  text-shadow: 0px 1px 1px $gray

@media (min-width: 576px)
  .product-text h2
    font-size: 2.5em

@media (min-width: 768px)
  .product-text h2
    font-size: 3em

  .product-container .product-details p
    margin-bottom: .3rem

@media (min-width: 992px)
  .product-text
    & h2
      font-size: 6em

  .carousel-item[data-v-4397edd1]
    font-size: 4em

@media (max-width: 575px)
  .product-text
    margin-top: 4rem

  .product-container .product-details
    padding: .5rem

  .product-container .product-details p
    margin-bottom: .5rem

@media (max-width: 768px)
  .product-text
    h2
      font-size: 2.25em !important
    p
      font-size: 0.8em
</style>
